var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRatio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.7991V14.5201C1 14.6474 1.05056 14.7694 1.14057 14.8594C1.23057 14.9494 1.35264 15 1.47992 15H3.20091C3.32795 15 3.44979 14.9496 3.53973 14.8599L11.6984 6.70124L9.29876 4.30164L1.14014 12.4603C1.05042 12.5502 1.00003 12.6721 1 12.7991ZM11.1647 2.43571L13.5643 4.83531L14.719 3.68062C14.8989 3.50063 15 3.25653 15 3.00202C15 2.7475 14.8989 2.50341 14.719 2.32341L13.6766 1.28103C13.4966 1.10109 13.2525 1 12.998 1C12.7435 1 12.4994 1.10109 12.3194 1.28103L11.1647 2.43571Z",
    stroke: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRatio);
export default __webpack_public_path__ + "static/media/edit-ratio.062e7c5ece18b629af2c4e9824ae6a8e.svg";
export { ForwardRef as ReactComponent };